const darkD75 = "#F5F5F7",
  darkD100 = "#E0E0E0",
  darkD200 = "#AEB1B5",
  darkD300 = "#575F6E",
  darkD400 = "#242731",
  redR400 = "#F46857",
  white = "#FFFFFF";

export { white, darkD200, darkD100, darkD75, darkD300, darkD400, redR400 };
